import React, { useEffect, useState } from 'react';
import DocumentService from '../../../../services/documents/document';
import LoadingComponent from '../../../feedbacks/loading';

type TypeRenderImageProps = {
  children?: React.ReactNode;
  path: string
  className?: string
  alt?: string
  style?: React.CSSProperties
};

const RenderImage: React.FC<TypeRenderImageProps> = (props) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const getIamgeData = async () => {
    try {
      setLoading(true);
      setError(false);
      const blob = (await DocumentService.get(props.path)).data.data;
      setImageSrc(blob);
    } catch (err) {
      console.log(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getIamgeData();
  }, [props.path]);


  return (
    <>
      {loading ? <LoadingComponent label={''} /> : null}
      {!loading && imageSrc ? <img style={props.style} className={props.className} src={`data:image/jpeg;base64,${imageSrc}`} alt={props.alt || "Gambar"} {...props} /> : null}
      {!loading && (error || !imageSrc) ? <span style={{ fontSize: '11px', color: '#8a8886', fontStyle: 'italic' }}>[Gambar tidak dapat dimuat]</span> : null}
    </>
  );
};

export default RenderImage;
